import React from 'react'
import PropTypes from 'prop-types'
import CallMadeIcon from '../../assets/CallMadeIcon'
import CallReceivedIcon from '../../assets/CallReceivedIcon'
import CallMissedIcon from '../../assets/CallMissedIcon'
import CallMadeMissedIcon from '../../assets/CallMadeMissedIcon'
import css from './patient-call-log.css'

const CallListItem = ({
  data: {
    formattedTime,
    formattedDate,
    call_start: callStart,
    duration,
    direction,
    friendly_extension: extension,
  },
}) => (
  <div className={css.callListItem}>
    <div className={css.dateDurationBox}>
      <h3>{`${formattedDate} | ${formattedTime}`}</h3>
      <p>{duration ? `Duration: ${duration}` : '(Missed)'}</p>
    </div>
    <div className={css.extensionBox}>
      <h3>{`Ext: ${extension}`}</h3>
    </div>
    <div className={css.iconBox}>
      {direction === 'inbound' && !callStart && <CallMissedIcon />}
      {direction === 'inbound' && callStart && <CallReceivedIcon />}
      {direction === 'outbound' && !callStart && <CallMadeMissedIcon />}
      {direction === 'outbound' && callStart && <CallMadeIcon />}
    </div>
  </div>
  )

CallListItem.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CallListItem



// WEBPACK FOOTER //
// ./src/components/PatientPage/Calls/CallListItem.js